import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CircleIcon from '@mui/icons-material/Circle';
import { getStatus } from '../../constants/Constant';

const useStyles = makeStyles(() => ({
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        color: '#fff',
        fontWeight: 500,
        fontSize: '0.65em',
    },
}));


const StatusDisplay = ({ status }) => {
    const classes = useStyles();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                itemCenter: 'center',
            }}>
            <Box className={classes.wrapper} style={{ fontSize: 16 }}>
                <CircleIcon
                    className={classes.icon}
                    style={{ color: getStatus(0) }}
                />
                <Typography component="span" className={classes.count}>
                    {status.todoCount + status.rejectCount}
                </Typography>
            </Box>
            <Box className={classes.wrapper} style={{ fontSize: 16 }}>
                <CircleIcon
                    className={classes.icon}
                    style={{ color: getStatus(1) }}
                />
                <Typography component="span" className={classes.count}>
                    {status.pendingCount}
                </Typography>
            </Box>
            <Box className={classes.wrapper} style={{ fontSize: 16 }}>
                <CircleIcon
                    className={classes.icon}
                    style={{ color: getStatus(2) }}
                />
                <Typography component="span" className={classes.count}>
                    {status.approvedCount}
                </Typography>
            </Box>
        </Box>
    );
};

const ModuleStatusIndicator = ({ status, keyProp, index }) => {
    const classes = useStyles();

    return (
        <>
            {status.module && status.module === keyProp.userID ? (
                <StatusDisplay status={status} key={index} />
            ) : status.userID === keyProp.userID ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        itemCenter: 'center',
                    }}
                    key={index}>
                    <Box className={classes.wrapper} style={{ fontSize: 16 }}>
                        <CircleIcon
                            className={classes.icon}
                            style={{ color: getStatus(0) }}
                        />
                        <Typography component="span" className={classes.count}>
                            {''}
                        </Typography>
                    </Box>
                </Box>
            ) : null}
        </>
    );
};

export default ModuleStatusIndicator;
